export type CreditAction = "credit_grant" | "credit_grant_reversal" | "credit_grant_bulk";

export type CreditAuditRow = {
  id: string;
  action: CreditAction;
  admin_user_id: string | null;
  target_user_id: string | null;
  created_at: string;
  metadata: Record<string, unknown>;
};

export type Identity = { display_name: string | null; email: string | null };

export type Summary = {
  granted: number;
  reversed: number;
  net: number;
  grant_count: number;
  reversal_count: number;
  bulk_summary_count: number;
};

export type Resp = {
  rows?: CreditAuditRow[];
  total?: number;
  identities?: Record<string, Identity>;
  summary?: Summary;
  error?: string;
};

export const PAGE_SIZE = 50;

export const CATEGORIES = [
  { value: "all", label: "All categories" },
  { value: "customer_service", label: "Customer service" },
  { value: "thank_you", label: "Thank you" },
  { value: "gift", label: "Gift" },
  { value: "promo", label: "Promotional" },
  { value: "other", label: "Other" },
] as const;

export const ACTIONS = [
  { value: "all", label: "All actions" },
  { value: "credit_grant", label: "Grant" },
  { value: "credit_grant_reversal", label: "Reversal" },
  { value: "credit_grant_bulk", label: "Bulk summary" },
] as const;

export const fmtDate = (iso: string) => new Date(iso).toLocaleString();
export const fmtNum = (n: number) => n.toLocaleString();

export const labelFor = (id: string | null, identities: Record<string, Identity>) => {
  if (!id) return "—";
  const ident = identities[id];
  if (!ident) return id.slice(0, 8) + "…";
  return ident.display_name || ident.email || id.slice(0, 8) + "…";
};
